import { render, staticRenderFns } from "./dataCenterScreen.vue?vue&type=template&id=8bd4e6fa&scoped=true&"
import script from "./dataCenterScreen.vue?vue&type=script&lang=js&"
export * from "./dataCenterScreen.vue?vue&type=script&lang=js&"
import style0 from "./dataCenterScreen.vue?vue&type=style&index=0&id=8bd4e6fa&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd4e6fa",
  null
  
)

component.options.__file = "dataCenterScreen.vue"
export default component.exports